module.exports = __webpack_public_path__ + "images/emoji/taurus.3b264b8bb6ae7639f763.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/taurus.png
// module id = 33PF
// module chunks = 2